"use client";

import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import React, { useEffect, useId, useRef } from "react";
import { createPortal } from "react-dom";
import { SingleWaveDropVote } from "../waves/drop/SingleWaveDropVote";
import ModalLayout from "../waves/memes/submission/layout/ModalLayout";
interface VotingModalProps {
  readonly drop: ExtendedDrop;
  readonly isOpen: boolean;
  readonly onClose: () => void;
}
const VotingModal: React.FC<VotingModalProps> = t0 => {
  const $ = _c(20);
  const {
    drop,
    isOpen,
    onClose
  } = t0;
  const titleId = useId();
  const modalRef = useRef(null);
  const previousActiveElement = useRef(null);
  const {
    isApp
  } = useDeviceInfo();
  let t1;
  let t2;
  if ($[0] !== isApp || $[1] !== isOpen || $[2] !== onClose) {
    t1 = () => {
      if (!isOpen) {
        return;
      }
      previousActiveElement.current = document.activeElement as HTMLElement;
      modalRef.current?.focus();
      const originalOverflow = document.body.style.overflow;
      if (!isApp) {
        document.body.style.overflow = "hidden";
      }
      const handleKeyDown = e => {
        if (e.key === "Escape") {
          onClose();
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        if (!isApp) {
          document.body.style.overflow = originalOverflow;
        }
        document.removeEventListener("keydown", handleKeyDown);
        previousActiveElement.current?.focus();
      };
    };
    t2 = [isOpen, onClose, isApp];
    $[0] = isApp;
    $[1] = isOpen;
    $[2] = onClose;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!isOpen) {
    return null;
  }
  let t3;
  if ($[5] !== onClose) {
    t3 = <div className="tw-fixed tw-inset-0" onClick={onClose} aria-hidden="true" />;
    $[5] = onClose;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== drop || $[8] !== onClose) {
    t4 = <SingleWaveDropVote drop={drop} onVoteSuccess={onClose} />;
    $[7] = drop;
    $[8] = onClose;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onClose || $[11] !== t4 || $[12] !== titleId) {
    t5 = <div className="tw-w-full tw-max-w-xl tw-z-10 tw-px-4" onClick={_temp2}><ModalLayout title="Vote for this artwork" onCancel={onClose} titleId={titleId}>{t4}</ModalLayout></div>;
    $[10] = onClose;
    $[11] = t4;
    $[12] = titleId;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== titleId) {
    t6 = <div ref={modalRef} role="dialog" aria-modal="true" aria-labelledby={titleId} tabIndex={-1} className="tailwind-scope tw-fixed tw-inset-0 tw-bg-iron-600/60 tw-z-50 tw-flex tw-items-center tw-justify-center tw-outline-none" onClick={_temp}>{t3}{t5}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = titleId;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const modalContent = t6;
  if (isApp) {
    return modalContent;
  }
  let t7;
  if ($[18] !== modalContent) {
    t7 = createPortal(modalContent, document.body);
    $[18] = modalContent;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default VotingModal;
function _temp(e_0) {
  return e_0.stopPropagation();
}
function _temp2(e_1) {
  return e_1.stopPropagation();
}